/**
 * Entry Point — minimal halten, alle Logik in app.js.
 */
import { app } from './core/app.js';

document.addEventListener('DOMContentLoaded', () => {
  app.init();
});
